export { TCSPhoneType } from './generated/TCSPhoneType.js';